import { render, staticRenderFns } from "./gate.vue?vue&type=template&id=05df8cb5&"
import script from "./gate.vue?vue&type=script&lang=js&"
export * from "./gate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports